<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Arboles Genéricos" key="1">
        <a-spin :spinning="loading">
          <a-row :gutter="[15,15]">
            <a-col :xs="24" :sm="12">
              <a-card style="min-height: 400px">
                <a-tree @select="onSelect" :defaultExpandAll="true" :tree-data="treeData" v-if="raizSeleccionada">
                  <template slot="title" slot-scope="node">{{node.name}} {{node.identificacion}} {{node.empleado}}
                  </template>
                </a-tree>
                <span v-else>Seleccione un arbol para previsualizar</span>
              </a-card>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-card style="min-height: 400px">
                <a-tabs defaultActiveKey="1">
                  <a-tab-pane tab="Arbol Seleccionado" key="1">
                    <form-model-dropdown style="width: 100%"
                                         v-model="raizSeleccionada"
                                         endpoint="generic_tree"
                                         :cache="false"
                                         placeholder="Arbol Seleccionado"
                                         :params="{root_only:true}"
                                         @change="raizCambiada"
                                         ref="arbolesDropdown">
                    </form-model-dropdown>
                  </a-tab-pane>
                  <a-tab-pane tab="Registrar Arbol Genérico" key="2">
                    <a-form-model :model="nuevoArbol" :rules="nuevoArbolRules" @submit="registrarArbol"
                                  @submit.native.prevent ref="registrarArbolForm">
                      <a-form-model-item :label="$t('Nombre Arbol')" prop="name" has-feedback>
                        <a-input style="width: 100%" v-model="nuevoArbol.name"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Tipo Arbol')" prop="id_h_type_node" has-feedback>
                        <form-model-dropdown style="width: 100%"
                                             endpoint="hierarchy_lookup"
                                             v-model="nuevoArbol.id_h_type_node"
                                             :params="request.tipo_arbol">
                        </form-model-dropdown>
                      </a-form-model-item>
                      <a-form-model-item>
                        <a-button type="primary" html-type="submit">
                          Registrar Abrol
                        </a-button>
                      </a-form-model-item>
                    </a-form-model>
                  </a-tab-pane>
                </a-tabs>
                <a-divider/>
                <a-tabs defaultActiveKey="1" v-if="nodoSeleccionado">
                  <a-tab-pane tab="Actualizar Nodo Seleccionado" key="1">
                    <a-form-model :model="nodoSeleccionado" :rules="editarNodoRules" @submit="editarNodo"
                                  @submit.native.prevent ref="editarNodoForm">

                      <a-form-model-item :label="$t('Tipo Arbol')" prop="id_h_type_node" has-feedback
                                         v-if="$isEmpty(nodoSeleccionado.parent_node)">
                        <form-model-dropdown style="width: 100%"
                                             endpoint="hierarchy_lookup"
                                             v-model="nodoSeleccionado.id_h_type_node"
                                             :params="request.tipo_arbol">
                        </form-model-dropdown>
                      </a-form-model-item>

                      <a-form-model-item :label="$t('Nombre Nodo')" prop="name" has-feedback>
                        <a-input style="width: 100%" v-model="nodoSeleccionado.name"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Empleado')" prop="id_emp" has-feedback>
                        <form-model-lookup style="width: 100%"
                                           endpoint="empleados"
                                           v-model="nodoSeleccionado.id_emp"
                                           placeholder="Empleado">
                        </form-model-lookup>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo 1')" prop="att_1" has-feedback>
                        <a-input style="width: 100%" v-model="nodoSeleccionado.att_1"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo 2')" prop="att_2" has-feedback>
                        <a-input style="width: 100%" v-model="nodoSeleccionado.att_2"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo Fecha 1')" prop="date_att_1" has-feedback>
                        <a-date-picker style="width: 100%"
                                       type="date"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-model="nodoSeleccionado.date_att_1"></a-date-picker>

                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo Fecha 2')" prop="date_att_2" has-feedback>
                        <a-date-picker style="width: 100%"
                                       type="date"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-model="nodoSeleccionado.date_att_2"></a-date-picker>

                      </a-form-model-item>
                      <a-form-model-item>
                        <a-button type="primary" html-type="submit">
                          Actualizar Nodo
                        </a-button>
                      </a-form-model-item>
                    </a-form-model>
                  </a-tab-pane>
                  <a-tab-pane tab="Registrar Nodo Hijo" key="2">
                    <a-form-model :model="nuevoNodo" :rules="registrarNodoRules" @submit="registrarNodo"
                                  @submit.native.prevent ref="registrarNodoForm">
                      <a-form-model-item :label="$t('Nombre Nodo')" prop="name" has-feedback>
                        <a-input style="width: 100%" v-model="nuevoNodo.name"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Empleado')" prop="id_emp" has-feedback>
                        <form-model-lookup style="width: 100%"
                                           endpoint="empleados"
                                           v-model="nuevoNodo.id_emp"
                                           placeholder="Empleado">
                        </form-model-lookup>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo 1')" prop="att_1" has-feedback>
                        <a-input style="width: 100%" v-model="nuevoNodo.att_1"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo 2')" prop="att_2" has-feedback>
                        <a-input style="width: 100%" v-model="nuevoNodo.att_2"></a-input>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo Fecha 1')" prop="date_att_1" has-feedback>
                        <a-date-picker style="width: 100%"
                                       type="date"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-model="nuevoNodo.date_att_1"></a-date-picker>
                      </a-form-model-item>
                      <a-form-model-item :label="$t('Atributo Fecha 2')" prop="date_att_2" has-feedback>
                        <a-date-picker style="width: 100%"
                                       type="date"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-model="nuevoNodo.date_att_2"></a-date-picker>
                      </a-form-model-item>
                      <a-form-model-item>
                        <a-button type="primary" html-type="submit">
                          Registrar Nodo
                        </a-button>
                      </a-form-model-item>
                    </a-form-model>
                  </a-tab-pane>
                  <a-tab-pane tab="Eliminar Nodo Seleccionado" key="3">
                    <a-button type="primary" html-type="submit"
                              @click="visibleConfirmaEliminarNodo = true">
                      Eliminar Nodo
                    </a-button>
                  </a-tab-pane>
                </a-tabs>
              </a-card>
            </a-col>
          </a-row>
        </a-spin>
      </a-tab-pane>
    </a-tabs>
    <a-modal v-model="visibleConfirmaEliminarNodo" title="Confirmación" :confirm-loading="loadingEliminarNodo" @ok="eliminarNodo" @cancel="visibleConfirmaEliminarNodo = false">
      <p>¿Esta seguro que desea eliminar este nodo?</p>
        <br>
        <br>
      <a-alert message="Al eliminar este nodo ya no será posible recuperar la información." type="info" show-icon />
    </a-modal>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from '../../../Util/Mensajes'

  export default {
    data () {
      return {
        visibleConfirmaEliminarNodo: false,
        loadingEliminarNodo: false,
        loading: false,
        raizSeleccionada: null,
        nodoSeleccionado: null,
        nuevoNodo: {},
        nuevoArbol: {
          name: null,
          id_h_type_node: null
        },
        nuevoArbolRules: {
          name: [{required: true, message: 'Valor Requerido'}],
          id_h_type_node: [{required: true, message: 'Valor Requerido'}]
        },
        editarNodoRules: {
          name: [{
            type: 'string',
            validator: (rule, value, callbackfn) => {
              if (JsUtils.isEmpty(this.nodoSeleccionado.name) && JsUtils.isEmpty(this.nodoSeleccionado.id_emp)) {
                callbackfn && callbackfn('El nombre o el empledo son requeridos')
                return false
              }
              callbackfn && callbackfn()
            }
          }],
          id_emp: [{
            type: 'string',
            validator: (rule, value, callbackfn) => {
              if (JsUtils.isEmpty(this.nodoSeleccionado.name) && JsUtils.isEmpty(this.nodoSeleccionado.id_emp)) {
                callbackfn && callbackfn('El nombre o el empledo son requeridos')
                return false
              }
              callbackfn && callbackfn()
            }
          }]
        },
        registrarNodoRules: {
          name: [{
            type: 'string',
            validator: (rule, value, callbackfn) => {
              if (JsUtils.isEmpty(this.nuevoNodo.name) && JsUtils.isEmpty(this.nuevoNodo.id_emp)) {
                callbackfn && callbackfn('El nombre o el empledo son requeridos')
                return false
              }
              callbackfn && callbackfn()
            }
          }],
          id_emp: [{
            type: 'string',
            validator: (rule, value, callbackfn) => {
              if (JsUtils.isEmpty(this.nuevoNodo.name) && JsUtils.isEmpty(this.nuevoNodo.id_emp)) {
                callbackfn && callbackfn('El nombre o el empledo son requeridos')
                return false
              }
              callbackfn && callbackfn()
            }
          }]
        },
        request: {
          tipo_arbol: {
            h_lookup_type: 'TIPO_ARBOL_GENERICO'
          }
        },
        treeData: []
      }
    },
    mounted () {
      this.httpClient = new HttpUtil('generic_tree')
    },
    methods: {
      onSelect (selectedKeys, info) {
        if (selectedKeys.length > 0) {
          let llaves = selectedKeys[0].toString().split('-')
          let llaveActual = null
          let nodoSeleccionado = null
          for (let i = 0; i < llaves.length; i++) {
            const llave = llaves[i]
            llaveActual = llaveActual ? llaveActual + '-' + llave : llave
            nodoSeleccionado = this.buscaNodo(llaveActual, nodoSeleccionado ? nodoSeleccionado.children : this.treeData)
          }
          this.nodoSeleccionado = nodoSeleccionado
        } else {
          this.nodoSeleccionado = null
        }
        this.nuevoNodo = {}
      },
      buscaNodo (key, nodos) {
        for (let i = 0; i < nodos.length; i++) {
          const nodo = nodos[i]
          if (nodo.key.toString() === key) {
            return nodo
          }
        }
        return null
      },
      raizCambiada (value) {
        this.nodoSeleccionado = null
        this.nuevoNodo = {}

        if (JsUtils.isEmpty(value)) {
          return
        }

        this.loading = true

        this.httpClient.getInstance().get('generic_tree/arbol/' + value)
          .then(response => {
            console.log(response.data)
            let result = {...response.data}
            this.asignaSlotRecursivo(result)
            this.treeData = [result]
          })
          .catch(error => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible consultar el arbol seleccionado.'))
          })
          .then(() => {
            this.loading = false
          })
      },
      registrarArbol () {
        this.$refs.registrarArbolForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.httpClient.create(this.nuevoArbol, (response) => {
              Mensajes.success('Correcto', 'Arbol registrado correctamente.')
              this.$refs.arbolesDropdown.loadOptions()
            }, (error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible crear el registro. Contacte al administrador'))
            }).then(() => {
              this.loading = false
            })
          }
        })
      },
      registrarNodo () {
        this.$refs.registrarNodoForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.nuevoNodo.parent_node = this.nodoSeleccionado.id
            this.httpClient.create(this.nuevoNodo, (response) => {
              Mensajes.success('Correcto', 'Nodo registrado correctamente.')
              this.raizCambiada(this.raizSeleccionada)
            }, (error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible crear el registro. Contacte al administrador'))
              this.loading = false
            })
          }
        })
      },
      editarNodo () {
        this.$refs.editarNodoForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.httpClient.update(this.nodoSeleccionado, (response) => {
              if (JsUtils.isEmpty(this.nodoSeleccionado.parent_node)) {
                this.$refs.arbolesDropdown.loadOptions()
              }
              Mensajes.success('Correcto', 'Nodo registrado correctamente.')
              this.raizCambiada(this.raizSeleccionada)
            }, (error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar el registro. Contacte al administrador'))
              this.loading = false
            })
          }
        })
      },
      asignaSlotRecursivo (tree) {
        if (!JsUtils.isEmpty(tree)) {
          tree.scopedSlots = {title: 'title'}
          tree.children && tree.children.forEach(c => {
            this.asignaSlotRecursivo(c)
          })
        }
      },
      eliminarNodo () {
        this.loadingEliminarNodo = true
        this.httpClient.delete(this.nodoSeleccionado.id,
          (response) => {
            console.log()
            if (response.data.message) {
              Mensajes.success('Se eliminó correctamente el nodo seleccionado')
              this.raizCambiada(this.raizSeleccionada)
            } else {
              Mensajes.info('No es posible eliminar este nodo ya que es la raíz del árbol')
            }
          },
          (error) => {
            Mensajes.success('Ocurrió un error durante la eliminación del nodo seleccionado')
          }
        )
          .then(() => {
            this.visibleConfirmaEliminarNodo = false
            this.loadingEliminarNodo = false
          })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GenericTree/GenericTree.vue